import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  IFXModal,
  IFXModalBody,
  IFXModalHeader,
  IFXModalFooter,
  IFXButton,
  IFXFieldWrapper,
  IFXTextBox,
  IFXFormLayout,
  IFXFormValidation,
  CoreValidationRuleCodes,
  IFXButtonGroup,
  IFXAccordion,
  IFXNumberTextBox2,
  useObservableCallback,
  AJAX_HEADER_APP_DEFAULT,
  useToast,
  IFXUserNote,
  IFXAlert,
  useObservable,
} from "@ifx-react/ifx-react-core";
import {
  GET_MASKEDE_MAIL,
  GENERATE_OTP,
  VERIFY_OTP,
  EMAIL_VERIFICATION_LIMIT,
} from "../../../const/portal/endpoints";
import { ajax } from "rxjs/ajax";
import { Subject } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { LayoutActions } from "../../../store/actions/common/actionCreators";
import { CommonToastConsts } from "../../../const/common/toastConsts";
import { useFormContext } from "react-hook-form";
import { Col, Row, Container } from "react-bootstrap";
import { APP_NAME } from "../../../components/common/PageTitle";

const defaultValues = {
  email: "",
  emailOTP: "",
};

const getMaskedEmailAjax$ = ({ errorHandler }) =>
  new Subject().pipe(
    mergeMap(({ userName }) => {
      return ajax
        .post(
          GET_MASKEDE_MAIL,
          {
            userName,
          },
          AJAX_HEADER_APP_DEFAULT
        )
        .pipe(
          map(xhrResponse => {
            return xhrResponse.response;
          }),
          catchError(error => {
            errorHandler(error);
            return [];
          })
        );
    })
  );

const getVerifyOtpAjax$ = ({ errorHandler }) =>
  new Subject().pipe(
    mergeMap(({ userName, emailOTP }) => {
      return ajax
        .post(
          VERIFY_OTP,
          {
            userName,
            emailOTP,
          },
          AJAX_HEADER_APP_DEFAULT
        )
        .pipe(
          map(xhrResponse => {
            return xhrResponse.response;
          }),
          catchError(error => {
            errorHandler(error);
            return [];
          })
        );
    })
  );

const generateOtpAjax$ = ({ errorHandler }) =>
  new Subject().pipe(
    mergeMap(({ userName }) => {
      return ajax
        .post(
          GENERATE_OTP,
          {
            userName,
          },
          AJAX_HEADER_APP_DEFAULT
        )
        .pipe(
          map(xhrResponse => {
            return xhrResponse.response;
          }),
          catchError(error => {
            errorHandler(error);
            return [];
          })
        );
    })
  );

const getEmailVerificationLimitReachedAjax$ = ({ errorHandler }) =>
  new Subject().pipe(
    mergeMap(({ userName }) => {
      return ajax
        .post(
          EMAIL_VERIFICATION_LIMIT,
          {
            userName,
          },
          AJAX_HEADER_APP_DEFAULT
        )
        .pipe(
          map(xhrResponse => {
            return xhrResponse.response;
          }),
          catchError(error => {
            errorHandler(error);
            return [];
          })
        );
    })
  );

const EmailNotVerifiedForm = ({
  onHide,
  commonErrorHandlerCallBack,
  username,
  maskedEmail,
  dispatch,
  otpModalCallBack,
  emailReEnter,
  getEmailVerificationLimitReached,
}) => {
  const { reset } = useFormContext();
  const [needHelpShow, setNeedHelpShow] = useState(false);
  const generateOtpObj$ = useMemo(() => {
    return generateOtpAjax$({
      errorHandler: error => commonErrorHandlerCallBack(error),
    });
  }, []);

  useObservableCallback(
    generateOtpObj$,
    response => {
      if (response === "success") {
      }
    },
    error => {
      console.error("error", error);
      dispatch(LayoutActions.SET_LOADER_HIDE());
    }
  );

  const [timer, setTimer] = useState(0);

  const resendOtp = () => {
    generateOtpObj$.next({
      userName: username,
    });
    setTimer(60);
  };

  const timeOutCallback = useCallback(
    () => setTimer(currTimer => currTimer - 1),
    []
  );

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  const onClear = () => {
    reset({
      emailOTP: "",
    });
  };

  const needHelp = () => {
    setNeedHelpShow(!needHelpShow);
  };

  return (
    <>
      <IFXModalBody disableBackground>
        <IFXAccordion title="" isOpen={true} enabled={true} isAccordion={false}>
          <IFXUserNote
            noBackground
            noBorder
            marginClassName="m-0 mb-2"
            paddingClassName="p-0 pt-1"
          >
            An email has been sent to the below address with a verification
            code. Please enter the verification code.
          </IFXUserNote>
          <IFXFormLayout allFieldsColProps={{ lg: 12 }}>
            <IFXFieldWrapper
              label="Email Address"
              controlId="email"
              name="email"
              disabled={true}
            >
              <IFXTextBox value={maskedEmail} />
            </IFXFieldWrapper>
            <IFXFieldWrapper
              label="Verification Code"
              controlId="emailOTP"
              name="emailOTP"
              rules={[CoreValidationRuleCodes.required]}
            >
              <IFXNumberTextBox2 maxLength={8} allowLeadingZero />
            </IFXFieldWrapper>
          </IFXFormLayout>
        </IFXAccordion>
      </IFXModalBody>
      <IFXModalFooter className="pb-0">
        <Container fluid className="p-0">
          <Row>
            <div className="ml-3 mt-2 d-inline-block">
              <IFXButton
                type="Select"
                name="Resend New Code"
                onClick={resendOtp}
                marginClassName="ml-1"
                disabled={timer !== 0}
              />
              <IFXButton
                type="Select"
                name="Change Email"
                marginClassName="ml-1"
                onClick={emailReEnter}
              />
            </div>
            {timer !== 0 && (
              <IFXUserNote
                noBackground
                noBorder
                marginClassName="m-0 mt-3 ml-1"
                paddingClassName="p-0 pl-1"
              >
                New verification code has been sent.
              </IFXUserNote>
            )}

            <IFXButtonGroup className="">
              <IFXButton type="submit" name="Verify" />
              <IFXButton type="clear" onClick={onClear} />
            </IFXButtonGroup>
          </Row>
          <Row>
            <Col className="pl-0">
              <IFXUserNote
                noBackground
                noBorder
                marginClassName="mt-1 mb-1"
                paddingClassName="pl-4"
              >
                <span className="cursor-pointer" onClick={needHelp}>
                  Need Help?
                </span>
              </IFXUserNote>
            </Col>
          </Row>
          {needHelpShow && (
            <Row>
              <Col>
                <IFXUserNote
                  paddingClassName="p-0"
                  marginClassName="m-1 mb-2"
                  noBackground
                  noBorder
                  animate={true}
                >
                  <div>
                    <div>
                      If you are having trouble accessing {APP_NAME},
                      <br /> or have any questions about the software suite,
                      <br /> Please contact our Help Desk.
                    </div>
                    <br />
                    <div>
                      <span>Phone: (+1) 571 370 9700</span>
                      <br />
                      <span>
                        Email:{" "}
                        <a href="mailto:support@paxiasolutions.com">
                          support@paxiasolutions.com
                        </a>
                      </span>
                    </div>
                  </div>
                </IFXUserNote>
              </Col>
            </Row>
          )}
        </Container>
      </IFXModalFooter>
    </>
  );
};

export const EmailNotVerifiedModal = ({
  show,
  onHide,
  username,
  otpModalCallBack,
  emailReEnter,
}) => {
  const dispatch = useDispatch();
  const { ifxErrorToast, ifxInfoToast } = useToast();
  const [maskedEmail, setMaskedEmail] = useState(null);
  const [modalShow, setModalShow] = useState(show);

  const getVerifyOtpObj$ = useMemo(() => {
    return getVerifyOtpAjax$({
      errorHandler: error => commonErrorHandler(error),
    });
  }, []);

  const getMaskedEmailObj$ = useMemo(() => {
    return getMaskedEmailAjax$({
      errorHandler: error => commonErrorHandler(error),
    });
  }, []);

  const getEmailVerificationLimitReachedObj$ = useMemo(() => {
    return getEmailVerificationLimitReachedAjax$({
      errorHandler: error => commonErrorHandler(error),
    });
  }, []);

  const getEmailVerificationLimitReached = useObservable(
    getEmailVerificationLimitReachedObj$,
    null
  );
  
  useObservableCallback(
    getMaskedEmailObj$,
    response => {
      setMaskedEmail(response);
      dispatch(LayoutActions.SET_LOADER_HIDE());
    },
    error => {
      console.error("error", error);
      dispatch(LayoutActions.SET_LOADER_HIDE());
    }
  );

  useObservableCallback(
    getVerifyOtpObj$,
    response => {
      if (response === "success") {
        otpModalCallBack(true);
        onHide();
      }
      dispatch(LayoutActions.SET_LOADER_HIDE());
    },
    error => {
      dispatch(LayoutActions.SET_LOADER_HIDE());
    }
  );

  useEffect(() => {
    dispatch(LayoutActions.SET_LOADER_SHOW());
    if (username) {
      getMaskedEmailObj$.next({ userName: username });
      getEmailVerificationLimitReachedObj$.next({ userName: username });
    }
  }, [username]);

  const handleOnSubmit = formValue => {
    LayoutActions.SET_LOADER_SHOW();
    getVerifyOtpObj$.next({
      userName: username,
      emailOTP: formValue.emailOTP,
    });
  };

  const commonErrorHandler = error => {
    console.error("error", error);
    dispatch(LayoutActions.SET_LOADER_HIDE());

    let msg =
      error.response && error.response?.message
        ? { content: error.response.message }
        : CommonToastConsts.ERROR;

    if (error?.response?.messageCode === "VERIFICATION_CODE_WRONG") {
      msg = { content: "Verification code does not match" };
    }

    ifxErrorToast(msg);

    if (error?.response?.messageCode === "MAX_OTP_VERIFICATION_LIMIT_REACHED") {
      onHide();
    }
  };

  const emailReEnterCallBack = () => {
    if (!getEmailVerificationLimitReached) {
      setModalShow(false);
      emailReEnter();
    } else {
      ifxInfoToast({
        content:
          "You have reached maximum email retry update limit, Your account is temporarily deactivated, Please contact support team",
      });
    }
  };

  return (
    <>
      {maskedEmail && (
        <IFXModal show={modalShow} onHide={onHide} size="md">
          <IFXModalHeader closeButton={false}>
            Email Verification
          </IFXModalHeader>
          <IFXFormValidation
            defaultValues={defaultValues}
            onSubmit={handleOnSubmit}
          >
            <EmailNotVerifiedForm
              onHide={onHide}
              username={username}
              maskedEmail={maskedEmail}
              commonErrorHandlerCallBack={commonErrorHandler}
              dispatch={dispatch}
              otpModalCallBack={otpModalCallBack}
              emailReEnter={emailReEnterCallBack}
              getEmailVerificationLimitReached={
                getEmailVerificationLimitReached
              }
            />
          </IFXFormValidation>
        </IFXModal>
      )}
    </>
  );
};
